module.exports = __webpack_public_path__ + "img/Event2.56c5c627.jpg";